import React from 'react'
import {get} from 'lodash'
import className from 'classnames'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import axios from 'axios'

import {t} from '@lib/helpers'

const DualSlide = dynamic(() => import('@components/DualSlide'))
const Meta = dynamic(() => import('@components/Meta'))

const Careers = ({careers = []}) => {
  return (
    <React.Fragment>
      <Meta title={`${t('pages.careers.title')} – ${t('layout.title')}`} />

      <div className='Careers'>
        <DualSlide
          height='150vh'
          initValue={[0, -100]}
          conditions={({ratio, tlySet}) => {
            if (ratio <= 0) {
              tlySet([0, -100])
            } else if (ratio > 0 && ratio <= 0.25) {
              tlySet([-100, 0])
            }
          }}
        >
          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--h1': true,
              'DualSlide__wrapper--h1--red': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.careers.dualslide.0.h2'),
                }}
              />

              <p className='DualSlide__p'>{t('pages.careers.dualslide.0.p')}</p>

              <div className='Buttons'>
                <a
                  className='DualSlide__a'
                  href='#info'
                  onClick={(e) => {
                    e.preventDefault()

                    window.history.pushState(null, null, '#info')
                    document
                      .querySelector('#info')
                      .scrollIntoView({behavior: 'smooth'})
                  }}
                />
              </div>
            </div>
          </div>

          <div
            className={className('DualSlide__wrapper', {
              'DualSlide__wrapper--alt': true,
              'DualSlide__wrapper--red': true,
            })}
          >
            <div className='DualSlide__wrapper__content'>
              <h2
                className='DualSlide__h2'
                dangerouslySetInnerHTML={{
                  __html: t('pages.careers.dualslide.1.h2'),
                }}
              />

              <p className='DualSlide__p'>{t('pages.careers.dualslide.1.p')}</p>
            </div>
          </div>

          <div className='DualSlide__image DualSlide__content--9'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--9.jpg'
            />
          </div>

          <div className='DualSlide__image DualSlide__content--8'>
            <img
              className='DualSlide__image__img'
              alt='DualSlide__image__img'
              src='/images/DualSlide--8.jpg'
            />
          </div>
        </DualSlide>

        <div className='Careers__video'>
          <div className='Careers__video__aspect-ratio'>
            <iframe
              src='https://www.youtube.com/embed/auQe8TAG6z8'
              title='YouTube video player'
              frameBorder='0'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              className='Careers__video__iframe'
            />
          </div>
          <h2 className='Careers__video__h2'>
            Life at <span className='Careers__video__span'>Data Wow</span>
          </h2>
        </div>

        <div className='BodySpace'>
          <div className='Anchor' id='info'></div>
          <div className='container'>
            <p className='Careers__p'>{t('pages.careers.p')}</p>

            <div className='Careers__benefits'>
              <img
                className='Careers__benefits__img'
                alt='Careers__benefits__img'
                src='/images/Careers__benefits__img.svg'
              />

              <div className='Careers__benefits__right'>
                <h2
                  className='Careers__benefits__right__h2'
                  dangerouslySetInnerHTML={{
                    __html: t('pages.careers.benefits.h2'),
                  }}
                />

                <p className='Careers__benefits__right__p'>
                  {t('pages.careers.benefits.p')}
                </p>

                <div className='Careers__benefits__right__list'>
                  <ul className='Careers__benefits__right__list__ul'>
                    {new Array(6).fill(0).map((x, i) => (
                      <li
                        key={i}
                        className='Careers__benefits__right__list__ul__li'
                      >
                        {t(`pages.careers.benefits.ul.${i}`)}
                      </li>
                    ))}
                  </ul>
                  <ul className='Careers__benefits__right__list__ul'>
                    {new Array(6).fill(0).map((x, i) => (
                      <li
                        key={i}
                        className='Careers__benefits__right__list__ul__li'
                      >
                        {t(`pages.careers.benefits.ul.${i + 6}`)}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            <div className='Careers__positions'>
              <h3
                className='Careers__positions__h3'
                dangerouslySetInnerHTML={{
                  __html: t('pages.careers.positions.h3'),
                }}
              ></h3>

              <div className='Careers__positions__link'>
                <Link href='/career-policy'>
                  {t('pages.careers.positions.notice')}
                </Link>
              </div>

              <dl className='Careers__positions__dl'>
                {careers.map((x, i) => (
                  <a
                    title={get(x, 'title')}
                    href={get(x, 'url')}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='Careers__positions__dl__item'
                    key={i}
                  >
                    <dt className='Careers__positions__dl__item__dt'>
                      {get(x, 'title')}
                    </dt>
                  </a>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

Careers.propTypes = {}

export const getServerSideProps = async (ctx) => {
  let careers = []

  try {
    const response = await axios.get(
      'https://datawow.workable.com/spi/v3/jobs?state=published',
      {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${process.env.WORKABLE_ACCESS_TOKEN}`,
        },
      }
    )

    if (response.status == 200) {
      careers = response.data.jobs
    }
  } catch (e) {}

  return {
    props: {
      careers,
    },
  }
}

export default Careers
